import CardTemplate from "components/card/card-template/CardTemplate";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "routes/constants";

const AuthenticationFailedCard = () => {
    const navigate = useNavigate();

    const handleNewApplication = () => {
        navigate(ROUTES.INVITATION);
    };

    return (
        <CardTemplate className="text-base-content min-h-[256px] tablet:min-h-[256px]" title="Authentication Failed">
            <div
                data-testid="authentication-failed-content"
                className="font-medium text-base-content text-base flex flex-col gap-4 pt-1"
            >
                <p className="text-base leading-[1.25] tracking-normal text-base-content pr-1 font-medium">
                    We were unable to authenticate you.
                </p>
                <p className="text-sm leading-[1.25] tracking-normal text-base-content pr-1 font-medium">
                    Please start a new application below.
                </p>
                <div className="flex justify-center">
                    <button
                        data-testid="new-application-button"
                        type="button"
                        onClick={handleNewApplication}
                        className="btn btn-primary w-[169px] h-[36px] text-white"
                    >
                        New Application
                    </button>
                </div>
            </div>
        </CardTemplate>
    );
};

export default AuthenticationFailedCard;
